var app = angular.module("leonardo");

var MaintenanceState = function($stateProvider) {

  $stateProvider.state('maintenance', {
    url: "/maintenance",
    cssClass: 'page-maintenance',
    templateUrl: 'views/templates/maintenance.html',
    controller: 'MaintenanceController',
    public: true,
  });

};

app.config(['$stateProvider', MaintenanceState]);
